import { isDevelopmentEnvironment } from "@/common/helpers/environment.helper";

export type ServiceMode = "simulation" | "http";

export const resolveServiceMode = (
  scenarioQueryParams: readonly string[],
  hostname: string = window.location.hostname,
  search: string = window.location.search
): ServiceMode => {
  const query = new URLSearchParams(search);
  return isDevelopmentEnvironment(hostname) && scenarioQueryParams.some((param) => query.has(param))
    ? "simulation"
    : "http";
};

export const cachedAdapters = <Service>(build: (mode: ServiceMode) => Service) => {
  const adapters = new Map<ServiceMode, Service>();
  return (mode: ServiceMode): Service => {
    const existing = adapters.get(mode);
    if (existing) return existing;
    const adapter = build(mode);
    adapters.set(mode, adapter);
    return adapter;
  };
};
